module.exports = function ($sce) {
    return function (htmlCode) {
        return htmlCode && htmlCode.length > 0 && typeof htmlCode === 'string'
            ? $sce.trustAsHtml(htmlCode)
            : htmlCode;
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-sanitize.js